import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, d = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M4.226 1.861a.75.75 0 0 1 .684-.441h4.84a.75.75 0 0 1 .683.441l.103.228a579.39 579.39 0 0 0 .364.801h1.58c.544 0 1.27.39 1.27 1.18V8.4a.75.75 0 0 1-1.5 0V4.39h-1.83a.752.752 0 0 1-.686-.444 198.652 198.652 0 0 1-.468-1.026H5.394l-.46 1.019a.75.75 0 0 1-.684.441H2.41v7.37h6.61a.75.75 0 0 1 0 1.5H2.18c-.295 0-.587-.094-.82-.271a1.109 1.109 0 0 1-.45-.879V4.03c0-.802.756-1.15 1.27-1.15h1.586l.46-1.019Z",
  "clip-rule": "evenodd"
}, null, -1), t = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M7.33 6.64a1.42 1.42 0 1 0 0 2.84 1.42 1.42 0 0 0 0-2.84ZM4.41 8.06a2.92 2.92 0 1 1 5.84 0 2.92 2.92 0 0 1-5.84 0Zm6.51 4.44a.75.75 0 0 1 .75-.75h2.66a.75.75 0 0 1 0 1.5h-2.66a.75.75 0 0 1-.75-.75Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M13 10.42a.75.75 0 0 1 .75.75v2.66a.75.75 0 0 1-1.5 0v-2.66a.75.75 0 0 1 .75-.75Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  d,
  t,
  n
];
function r(h, s) {
  return l(), o("svg", a, [...c]);
}
const u = { render: r };
export {
  u as default,
  r as render
};
